document.addEventListener('DOMContentLoaded', function () {
    
// Initialize Swiper for all instances
    document.querySelectorAll('.featured-collection__swiper').forEach(function (swiperElement) {

        if (swiperElement.dataset.swiperInitialized === 'true') {
            console.warn(`Swiper with ID ${swiperElement.dataset.swiperId} is already initialized.`);
            return;
          }

        const swiperId = swiperElement.dataset.swiperId;
        const loopSetting = swiperElement.dataset.loop === 'true';
        
        new Swiper(`.featured-collection__swiper[data-swiper-id="${swiperId}"]`, {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: loopSetting,
        direction: 'horizontal',

        // Navigation arrows
        navigation: {
            nextEl: `.featured-collection__next[data-swiper-id="${swiperId}"] `,
            prevEl: `.featured-collection__prev[data-swiper-id="${swiperId}"] `,
        },

        // Scrollbar
        scrollbar: {
            el: `.featured-collection__scrollbar[data-swiper-id="${swiperId}"] `,
        },

        breakpoints: {
            750: {
            slidesPerView: 2,
            spaceBetween: 30,
            },
        },
        });

        swiperElement.dataset.swiperInitialized = 'true';
    });
});